<div class="custom-scrollbar">
  <ul class="steps-list list-unstyled">
    @for (step of steps; track step; let i = $index) {
      <li class="{{ i === activeStep ? 'active-step' : i < activeStep && showProgress ? 'completed-step' : 'inactive-step' }}" (click)="setStep(i)">
        @if (stepIcons.length) {
          <span class="mts-icon notranslate step-icon" translate="no">{{stepIcons[i]}}</span>
        }
        @if (!stepIcons.length) {
          <span class="step-number">{{ i + 1 }}</span>
        }
        <span class="step-title truncate-text-one-line">{{ step }}</span>
      </li>
    }
  </ul>
</div>
